import styled, { css } from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import UnderlineTitle from '../UnderlineTitle'
import FormFieldSelect from '../form/fields/FormFieldSelect'
import FormFieldInput from '../form/fields/FormFieldInput'
import ActionButton from '../ActionButton'
import FormikForm from '../form/FormikForm'

export const Title = styled(UnderlineTitle)`
  margin-bottom: 2.4rem;

  ${breakpoints.up('tablet')} {
    margin-bottom: 4rem;
  }
`

export const Form = styled(FormikForm)``

export const Select = styled(FormFieldSelect)``

export const Inputs = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 2.4rem 0;
  gap: 1.6rem;

  ${breakpoints.up('tablet')} {
    margin: 4rem 0;
    gap: 2.4rem;
  }
`

export const Input = styled(FormFieldInput)`
  max-width: 37rem;
  width: 100%;
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 1.6rem;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
    gap: 2.4rem;
  }
`

export const Button = styled(ActionButton)`
  width: max-content;
`

export const Container = styled.div<{ $isInEditMode: boolean }>`
  background-color: ${({ theme, $isInEditMode }) =>
    $isInEditMode ? theme.colors.royalBlue : 'transparent'};

  border: ${({ theme, $isInEditMode }) =>
    $isInEditMode ? 'none' : `1px solid ${theme.colors.neonBlue}`};
  border-radius: ${({ $isInEditMode }) => ($isInEditMode ? '0' : '2rem')};
  padding: 2.4rem;

  ${breakpoints.up('tablet')} {
    padding: 3.2rem 5.2rem;
  }

  ${({ $isInEditMode }) =>
    $isInEditMode &&
    css`
      ${Title} {
        color: ${({ theme }) => theme.colors.pureWhite};
        &::after {
          background-color: ${({ theme }) => theme.colors.pureWhite};
        }
      }

      ${Select} {
        & p {
          color: ${({ theme }) => theme.colors.pureWhite};
        }
      }

      & label {
        color: ${({ theme }) => theme.colors.pureWhite};
      }

      ${Input} {
        & label::after {
          color: ${({ theme }) => theme.colors.pureWhite};
        }
      }
    `}
`
